/**
 * How `intent` reaches the toast surface.
 *
 * `ToastBar`'s render prop hands back react-hot-toast's own toast object, and the intent rides across
 * on `className` rather than as a field of its own. Internal to this component pair: callers set
 * `intent` on `useToast` and never see this.
 *
 * `className` is not the only channel available — `Toast.type` is first-class on react-hot-toast's
 * object (`hotToast.error()` sets it) and this component reads it for nothing, so `t.type === 'error'`
 * would work in the same place and delete this file. It stays on `className` because the switch is
 * purely internal (this constant is not exported from the barrel, so no caller can see either
 * spelling) and the cost of changing it later is therefore flat. Two things to know if you do change
 * it: the exact string equality below degrades to neutral the moment a second class or a second
 * intent appears, and react-hot-toast renders `className` onto the toast wrapper, so this string is
 * visible in the DOM with no CSS behind it.
 */
export const TOAST_DESTRUCTIVE_CLASS = 'joykit-toast--destructive';
